// @flow
import React, { Component } from 'react';
import {
  PartnerInfoCard,
  PartnerInfoBigBlockDiv,
  CommissionRateDiv,
  ContractInfoH5,
  PartnerInfoSmallBlockDiv,
  PartnerInfoDefaultMerchantFeeH5,
  PartnerInfoMerchantFeesDiv,
  ContractAgreementP,
  CustomDefaultIcon,
  ContractInfoP
} from './InformationStyles';
import { type ReferralDetails, type Currency } from '../../../utilities/types';
import { formatCurrency } from '../../../utilities/numberFormatting';
import InfoTooltip from '../../../components/InfoTooltip';
import { Default, Mobile } from '../../../components/Responsive';

type Props = {
  referralDetails: ReferralDetails,
  partnerCurrency: Currency,
  activeTooltip: ?string,
  showTooltip: (tooltip: string) => void
};

export default class ContractInfoBlock extends Component<Props> {
  render() {
    return (
      <PartnerInfoCard>
        <PartnerInfoBigBlockDiv>
          <CommissionRateDiv>
            <ContractInfoH5>Agreement</ContractInfoH5>
            <ContractAgreementP
              underline={this.props.referralDetails.agreement}
            >
              {this.props.referralDetails.agreement || '---'}
              {this.props.referralDetails.agreement && (
                <CustomDefaultIcon name="extLink" />
              )}
            </ContractAgreementP>
          </CommissionRateDiv>

          <CommissionRateDiv>
            <Default>
              <ContractInfoH5>Contract starting date</ContractInfoH5>
            </Default>
            <Mobile>
              <ContractInfoH5>Contract Details</ContractInfoH5>
            </Mobile>

            <ContractInfoP>
              {this.props.referralDetails.start_date || '---'}
            </ContractInfoP>
          </CommissionRateDiv>
        </PartnerInfoBigBlockDiv>

        <PartnerInfoSmallBlockDiv>
          <PartnerInfoDefaultMerchantFeeH5>
            Contract Details{' '}
            {Boolean(this.props.referralDetails.notes) && (
              <InfoTooltip
                message={this.props.referralDetails.notes || ''}
                showTooltip={this.props.showTooltip}
                activeTooltip={this.props.activeTooltip}
                tooltipName="CONTRACT_DETAILS_TOOLTIP"
                smallIcon
              />
            )}
          </PartnerInfoDefaultMerchantFeeH5>
          <PartnerInfoMerchantFeesDiv>
            <h5> Min. transaction vol.</h5>
            <p>
              {this.props.referralDetails.min_processing_volume
                ? formatCurrency(
                    this.props.referralDetails.min_processing_volume || NaN,
                    this.props.partnerCurrency
                  )
                : '--- '}
              /month
            </p>
          </PartnerInfoMerchantFeesDiv>
          <PartnerInfoMerchantFeesDiv>
            <h5>monthly min. Starting</h5>
            <p>
              {this.props.referralDetails.min_processing_effective || '---'}
            </p>
          </PartnerInfoMerchantFeesDiv>
        </PartnerInfoSmallBlockDiv>
      </PartnerInfoCard>
    );
  }
}
